var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"banner"},[_c('h3',{staticClass:"banner__message wb-type-copy-strong"},[_c('wb-icon',{staticClass:"banner__icon",class:_vm.isRTLClass,attrs:{"name":_vm.icon}}),_vm._v(" "+_vm._s(_vm.message)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }